module.exports = __webpack_public_path__ + "static/img/select-class-vehicle.c74b6c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/select-class-vehicle.svg
// module id = sWbv
// module chunks = 1